var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230 301.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a6d8e3;}.cls-2{fill:#f2abc6;}.cls-3{fill:#343231;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133,229.33H83.24a128.92,128.92,0,0,1-38.61,27.35s9.1,34,12,44.72c0,0,103.56-16.5,163-86.49l-13.86-8.41A126.63,126.63,0,0,1,133,229.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 230,
    height: 230,
    rx: 44.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.48,136.43a4.31,4.31,0,0,1-3.85-6.24l9.84-19.69a4.31,4.31,0,0,1,7.71,3.86l-9.85,19.69A4.31,4.31,0,0,1,37.48,136.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.47,136.43a4.32,4.32,0,0,1-3.85-6.24l9.85-19.69a4.31,4.31,0,1,1,7.7,3.86l-9.84,19.69A4.33,4.33,0,0,1,53.47,136.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.47,136.43a4.24,4.24,0,0,1-1.92-.46,4.31,4.31,0,0,1-1.93-5.78l9.84-19.69a4.31,4.31,0,0,1,7.71,3.86l-9.85,19.69A4.31,4.31,0,0,1,69.47,136.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.68,136.43a4.32,4.32,0,0,1-3.85-6.24l9.85-19.69a4.31,4.31,0,0,1,7.7,3.86l-9.84,19.69A4.33,4.33,0,0,1,150.68,136.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.68,136.43a4.31,4.31,0,0,1-3.85-6.24l9.84-19.69a4.31,4.31,0,0,1,7.71,3.86l-9.85,19.69A4.31,4.31,0,0,1,166.68,136.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.67,136.43a4.32,4.32,0,0,1-3.85-6.24l9.85-19.69a4.31,4.31,0,1,1,7.7,3.86l-9.84,19.69A4.33,4.33,0,0,1,182.67,136.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50,94.49a3.78,3.78,0,0,1-.17-.6c-2.2-12.37,21.42-15.54,29-13.15a32.05,32.05,0,0,1,10.93,6c1.2,1,8.92,10.67,3.37,10.8a3.93,3.93,0,0,1-2.24-.92C85.86,93,83.16,87.74,76.77,86.21a20.51,20.51,0,0,0-19.61,5.9C55.61,93.79,51.71,98.56,50,94.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.37,94.49a2.43,2.43,0,0,0,.17-.6c2.21-12.37-21.42-15.54-29-13.15a32.05,32.05,0,0,0-10.93,6c-1.2,1-8.92,10.67-3.37,10.8a3.9,3.9,0,0,0,2.24-.92c5.07-3.59,7.77-8.89,14.17-10.42a20.5,20.5,0,0,1,19.6,5.9C181.79,93.79,185.69,98.56,187.37,94.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.14,143.69a10.51,10.51,0,0,1,9.72,14.5c-6.65,16.33-24.23,28-44.86,28s-38.21-11.67-44.86-28a10.51,10.51,0,0,1,9.72-14.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.99b5161aca94ce93152c222578ec5ebb.svg";
export { ForwardRef as ReactComponent };